<div class="box card-box shadow" *ngIf="empModelFamiliesWithOptions?.length">
  <div class="box-header">
    <h3>{{ 'EMPLOYEE_HIRE.file_type' | translate }}</h3>
  </div>

  <div class="box-body">
    <div class="row" *ngIf="modelsLoading">
      <div class="col-md-12 text-center">
        <em class="fa fa-light fa-spinner fa-spin"></em>
      </div>
    </div>
    <div class="row" test-id="ng-select" *ngIf="!modelsLoading" [formGroup]="employeeModelForm">
      <div class="col-md-12" *ngFor="let model of empModelFamiliesWithOptions">
        <!-- Model 1 -->
        <div class="form-group">
          <label [attr.test-id]="'employee-model-label-' + model.familyName">{{ model.familyTransId | translate }}<span
            *ngIf="model.isRequired">&nbsp;*</span></label>
          <select class="form-control" [attr.test-id]="'employee-model-select-' + model.familyName"
                  [formControlName]="model.familyName">
            <option *ngIf="!model.isRequired"></option>
            <option *ngFor="let option of model.options" [ngValue]="option">
              {{ option.transId | translate }}
            </option>
          </select>

          <ul class="error-list">
          </ul>

        </div>
      </div>
    </div>
  </div>
</div>
